import { postData } from "@/__main__/get-data.mjs";
import { appURLs } from "@/app/constants.mjs";
import noOp from "@/data-models/no-op.mjs";
import * as GraphQLTemplates from "@/game-lol/graphql-templates.mjs";
import { postGQL } from "@/util/gql-formatters.mjs";

export default function postPostmatchLPElixir(params: {
  region: string;
  leagueProfileId: string;
  championId: number;
  queue: string;
  role: string;
  lp: number;
  gameId: string;
  deltaLp: number;
  division: string;
  tier: string;
}) {
  const {
    region,
    leagueProfileId,
    championId,
    queue,
    role,
    lp,
    gameId,
    deltaLp,
    division,
    tier,
  } = params;
  return postData(
    postGQL(appURLs.ANALYTICS, GraphQLTemplates.updateSummonerLpStats, {
      region,
      leagueProfileId,
      championId,
      queue,
      role: role === "BOT" ? "ADC" : role,
      lp,
      gameId: `${gameId}`,
      deltaLp,
      division,
      tier,
      // ratedRating,
      // ratedRatingDelta,
      // ratedTier,
    }),
    noOp,
    undefined,
    undefined,
  );
}
